module.exports = __webpack_public_path__ + "img/8f8e2df.jpg";